// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2kLCP","unreadBadge":"styles_unreadBadge__2mqkU","modalContent":"styles_modalContent__1cRLN","modal":"styles_modal__2CVRO"};